import React from "react";
import cv from '../internalAsset/Daniel_Herrmann_CV_Aug1126.pdf.pdf'
const Contact = () => {
  return (
    <div className="row">
      <div
        className="twelve columns"
        style={{ marginLeft: 0, marginBottom: "0rem" }}
      >
        <h2>Contact Info</h2>
        <div className="four columns subhead">
          <div
            className="twelve columns"
            style={{ marginLeft: 0, marginBottom: "5rem" }}
          >
            <h6>Email</h6>
            <div className="ten columns subheadSmaller">
              <p style={{ marginBottom: "1.5rem" }}>
                danher [at] unc [dot] edu
              </p>
            </div>
          </div>
        </div>

        
      <div className="four columns subhead">
          <div
            className="twelve columns"
            style={{ marginLeft: 0, marginBottom: "5rem" }}
          >
             
            <h6>Meet with me</h6>
            <div className="ten columns subheadSmaller">
              <p style={{ marginBottom: "1.5rem" }}>
                <a href="https://calendar.app.google/a9djVLjD4V9H1eSBA">Meet</a>
              </p>
              
            </div>
            </div>
          </div>


        <div className="four columns subhead">
          <div
            className="twelve columns"
            style={{ marginLeft: 0, marginBottom: "5rem" }}
          >
            <h6>CV</h6>
            <div className="ten columns subheadSmaller">
              <p style={{ marginBottom: "1.5rem" }}>
                <button onClick={() => {
                  window.open(cv)
                }}>PDF Format</button>
              </p>
            </div>
          </div>
        </div>


      </div>
    </div>
  );
};

export default Contact;
